import React, { forwardRef } from 'react';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  className = '',
  ...props
}, ref) => {
  return <div className={`flex flex-col w-full ${className}`} data-id="element-172">
        <label className="text-xs font-medium text-luxury-gray uppercase tracking-wider mb-2 ml-1" data-id="element-173">
          {label}{' '}
          {props.required && <span className="text-luxury-gold" data-id="element-174">*</span>}
        </label>
        <input ref={ref} className={`w-full bg-luxury-darkgray/50 border ${error ? 'border-red-500/50' : 'border-white/10'} rounded-xl px-4 py-3.5 text-luxury-white placeholder:text-luxury-gray/50 focus:outline-none focus:border-luxury-gold focus:ring-1 focus:ring-luxury-gold transition-colors allow-select`} {...props} data-id="element-175" />
        {error && <span className="text-xs text-red-400 mt-1.5 ml-1" data-id="element-176">{error}</span>}
      </div>;
});
Input.displayName = 'Input';